import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import servicioCambiosCic from "../../../../servicios/servicioCambiosCic";
import { Notificar } from "../../../Comunes/Notificador";

function RechazarSolicitudModal({ solicitud, regresarAListaSolicitudes }) {
  const [show, setShow] = useState(false);
  const [comentario, setComentario] = useState("");

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const parametro = {
      solicitud: solicitud.solicitud,
      comentario: comentario,
    };

    const resultado = await servicioCambiosCic.RechazarUnaSolicitudCambio(
      parametro
    );

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    handleClose();
    regresarAListaSolicitudes({
      solicitud: resultado.solicitud,
    });
    Notificar("success", resultado.mensaje);
  };

  return (
    <>
      <button
        className="btn btn-danger btn-icon-split mr-3"
        onClick={handleShow}
      >
        <span className="icon text-white-50">
          <i className="far fa-times-circle"></i>
        </span>
        <span className="text">Rechazar</span>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Rechazar Solicitud</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group controlId="comentario">
              <Form.Label>Comentario</Form.Label>
              <Form.Control
                name="comentario"
                as="textarea"
                rows={3}
                maxLength="999"
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default RechazarSolicitudModal;
